<template>
  <section class="full viz-container">
    <div class="color-source">
      <div class="title">
        Color Source
      </div>
      <a class="btn" @click="redrawViz(1)" :class="{ 'selected': colorSource==1 }">Unsplash</a>
      <a class="btn" @click="redrawViz(3)" :class="{ 'selected': colorSource==3 }">Image Palette</a>

      <div class="creditBox">
        <div class="credits" v-if="displayCredit">
          <a :href="unsplashUsernameURL" target="_blank">Photo by {{ unsplashUsernameName }}</a> on
          <a :href="$root.unsplashURL + utmStr" target="_blank">Unsplash</a>

          <div @click="removeImage" class="close icofont-close" />
        </div>
      </div>
    </div>

    <div v-if="!dataLoaded" class="preloader">
      <img
        class="wait"
        src="/assets/images/ajax-loader.gif"
        alt="... won't be long ..."
      >
      <p>... won't be THAT long ...</p>
    </div>
    <div id="color-viz" class="d3-viz color-viz">
      <div id="tooltip" @click="displayImageInShowbox($event)" class="tooltip">
        <div class="pointer" id="pointer">
          <p class="view" id="view-btn">
            View
          </p>
        </div>
        <div @click.stop="removeToolTip" class="close icofont-close" />
        <div class="palette">
          <div id="p1" />
          <div id="p2" />
          <div id="p3" />
          <div id="p4" />
          <div id="p5" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ColorViz from "../js/color-canvas/d3-color"
import Helper from "../js/d3-common"

export default {
    name: "ColorCanvasViz",
    data() {
        return {
            dataLoaded: false,
            data: null,
            displayCredit: false,
            unsplashUsernameURL: "",
            unsplashURL: "",
            unsplashUsernameName: "",
            utmStr: this.$root.unsplashUTM + "color",
            colorSource: 1
        }
    },
    mounted() {

        const colorviz = new ColorViz("color-viz")
        this.colorviz = colorviz

        colorviz.loadData("unsplash-colors-combined").then(json => {
            this.dataLoaded = true
            this.data = json
            this.colorviz.colorSource = this.colorSource
            this.colorviz.init()
            this.colorviz.drawBase()
            this.colorviz.drawContent()
        })

        window.addEventListener("resize", () => {
            this.resizeDebounced()
        })
    },
    methods: {
        resizeDebounced: _.debounce(function draw() {
            this.redrawViz()
        }, 250),

        removeToolTip() {
            this.colorviz.hideToolTip()
        },
        redrawViz(colorsource = 0) {
            if (colorsource > 0) {
                this.colorSource = colorsource
                this.colorviz.colorSource = this.colorSource
            }
            this.colorviz.redraw()
        },
        displayImageInShowbox(event) {
            const id = event.target.dataset.id
            const photo = this.data.find(obj => obj.id == id)

            const imgEl = document.getElementById("bg")
            const pointer = document.getElementById("pointer")
            const tempImage = pointer.style.backgroundImage

            const innerWidth = window.innerWidth
            const innerHeight = window.innerHeight
            pointer.style.backgroundImage = "url('/assets/images/loading.gif')"

            Helper.loadImage(
                `${photo.urls.raw}&w=${innerWidth}&h=${innerHeight}&fit=crop&q=85&fm=jpg&crop=entropy&cs=srgb`
            ).then(img => {
                const photoURL = img.src
                imgEl.style.backgroundImage = "url(" + photoURL + ")"
                pointer.style.backgroundImage = tempImage

                this.displayCredits(photo)
            })
        },
        displayCredits(photoData) {
            // console.log(photoData);
            let utmStr = this.$root.unsplashUTM + "color"
            this.unsplashURL = "https://unsplash.com/" + utmStr
            this.unsplashUsernameURL =
        this.$root.unsplashURL + "@" + photoData.user.username + utmStr
            let firstName = photoData.user.first_name
            let lastName = photoData.user.last_name
            if (firstName == null) {
                firstName = ""
            }
            if (lastName == null) {
                lastName = ""
            }
            this.unsplashUsernameName = `${firstName} ${lastName}`
            this.displayCredit = true
        },
        removeImage(photoData) {
            const imgEl = document.getElementById("bg")
            imgEl.style.backgroundImage = ""

            this.removeToolTip()
            this.displayCredit = false
        }
    }
}
</script>

<style scoped lang="stylus">
.wrapper {
  fill: none;
  stroke: #646464;
  stroke-width: 1px;
  stroke-dasharray: 2, 2;
  stroke-linejoin: round;
}

.full {
  text-align: center;

  & div {
    // width: 100%;
  }

  & .preloader {
    margin: 100px auto;
    text-align: center;
  }

  & .color-source {
    text-align: left;
    font-size: 12px;

    & .title {
      padding: 4px 20px;
      display: inline-block;
    }

    & a.btn {
      padding: 10px 15px;
      margin: 0 5px;
      border: 1px solid darkgrey;
      cursor: pointer;
      background: rgba(255, 255, 255, 0.5);
      color: #708090;

      &.selected {
        color: black;
        background: rgba(255, 255, 255, 0.9);
      }

      &:hover {
        // color: black;
        background: rgba(255, 255, 255, 0.8);
      }
    }

    & .creditBox {
      position: relative;
      display: inline-block;
      text-align: left;
      z-index: 15;
      border: none;

      & .credits {
        font-size: 14px;
        background: rgba(255, 255, 255, 0.9);
        margin: 5px 40px;
        display: inline;
        padding: 8px 24px 8px 16px;
        position: relative;

        & a {
          display: inline-block;
          padding: 8px 0;
        }

        & .close {
          position: absolute;
          text-align: center;
          width: 20px;
          height: 20px;
          line-height: 21px;
          top: 2px;
          right: -14px;
          border-radius: 20px;
          border: 3px solid darkgrey;
          background-color: white;
          cursor: pointer;
          box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.6);
        }
      }
    }
  }

  & .d3-viz >>> canvas {
    position: absolute;
    // border: 1px solid blue;
    top: 0;
    left: 0;
  }

  & .d3-viz {
    width: 100%;
    height: 80vh;
    margin: 0 auto;
    text-align: center;
    position: relative;

    & .tooltip {
      position: absolute;
      z-index: 3;
      // width: 200px;
      opacity: 0;

      & .pointer {
        position: relative;
        width: 150px;
        height: 150px;
        background-size: cover;
        display: block;
        border-radius: 80px;
        border: 4px solid darkgrey;

        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 15px;
          height: 15px;
          background: darkgrey;
          border-top-color: transparent;
          border-left-color: transparent;
          transform: translate(-50%, 50%) rotate(45deg);
          transform-origin: center center;
          z-index: -2;
        }

        &:hover {
          cursor: pointer;

          & p.view {
            background: rgba(255, 255, 255, 0.85);
            box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
          }
        }

        & p.view {
          font-family: 'Muli', sans-serif;
          font-weight: 600;
          font-size: 14px;
          margin: 60px 20px 0;
          padding: 3px;
          z-index: 3;
          color: black;
          background: rgba(255, 255, 255, 0.5);
          border-radius: 5px;
          transition: all 0.2s ease-out;
        }
      }

      & .palette {
        position: absolute;
        top: 8px;
        left: -10px;

        // border: 1px solid red
        & div {
          border: 1px solid black;
          margin: 5px 0;
          width: 20px;
          height: 20px;
          border-radius: 12px;
          background-color: white;
        }
      }

      & .close {
        position: absolute;
        width: 20px;
        height: 20px;
        line-height: 21px;
        top: 15px;
        right: 5px;
        border-radius: 20px;
        border: 4px solid darkgrey;
        background-color: white;
        cursor: pointer;
      }
    }
  }
}
</style> 
